export type DASHBOARD_HAS_ERRORED = typeof DASHBOARD_HAS_ERRORED
export const DASHBOARD_HAS_ERRORED = '[Dashboard] DASHBOARD_HAS_ERRORED'

export type GET_TASKS_IN_PROGRESS = typeof GET_TASKS_IN_PROGRESS
export const GET_TASKS_IN_PROGRESS = '[Dashboard] GET_TASKS_IN_PROGRESS'

export const GET_TASKS_IN_PROGRESS_SUCCESS = '[Dashboard] GET_TASKS_IN_PROGRESS_SUCCESS'
export type GET_TASKS_IN_PROGRESS_SUCCESS = typeof GET_TASKS_IN_PROGRESS_SUCCESS

export type GET_ACCOUNTING_OVERVIEW = typeof GET_ACCOUNTING_OVERVIEW
export const GET_ACCOUNTING_OVERVIEW = '[Dashboard] GET_ACCOUNTING_OVERVIEW'

export const GET_ACCOUNTING_OVERVIEW_SUCCESS = '[Dashboard] GET_ACCOUNTING_OVERVIEW_SUCCESS'
export type GET_ACCOUNTING_OVERVIEW_SUCCESS = typeof GET_ACCOUNTING_OVERVIEW_SUCCESS

export type SET_ACCOUNTING_OVERVIEW_PERIOD = typeof SET_ACCOUNTING_OVERVIEW_PERIOD
export const SET_ACCOUNTING_OVERVIEW_PERIOD = '[Dashboard] SET_ACCOUNTING_OVERVIEW_PERIOD'

export type GET_DEPARTMENT_OVERVIEW = typeof GET_DEPARTMENT_OVERVIEW
export const GET_DEPARTMENT_OVERVIEW = '[Dashboard] GET_DEPARTMENT_OVERVIEW'

export const GET_DEPARTMENT_OVERVIEW_SUCCESS = '[Dashboard] GET_DEPARTMENT_OVERVIEW_SUCCESS'
export type GET_DEPARTMENT_OVERVIEW_SUCCESS = typeof GET_DEPARTMENT_OVERVIEW_SUCCESS

export type GET_PROJECTS_DASHBOARD_STATS = typeof GET_PROJECTS_DASHBOARD_STATS
export const GET_PROJECTS_DASHBOARD_STATS = '[Dashboard] GET_PROJECTS_DASHBOARD_STATS'

export const GET_PROJECTS_DASHBOARD_STATS_SUCCESS = '[Dashboard] GET_PROJECTS_DASHBOARD_STATS_SUCCESS'
export type GET_PROJECTS_DASHBOARD_STATS_SUCCESS = typeof GET_PROJECTS_DASHBOARD_STATS_SUCCESS

export type GET_PROJECTS_IN_DANGER = typeof GET_PROJECTS_IN_DANGER
export const GET_PROJECTS_IN_DANGER = '[Dashboard] GET_PROJECTS_IN_DANGER'

export const GET_PROJECTS_IN_DANGER_SUCCESS = '[Dashboard] GET_PROJECTS_IN_DANGER_SUCCESS'
export type GET_PROJECTS_IN_DANGER_SUCCESS = typeof GET_PROJECTS_IN_DANGER_SUCCESS
